import React, { useEffect, useMemo, useState } from 'react'

import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';

import { ErrorSwal, SuccessSwal } from '../../../shared/helpers/swal'
import { Col, Row } from 'reactstrap';
import { getMantenedores } from '../../../shared/helpers/api/apiCall';
import { DriverSelect } from './DriverSelect';
import { DatosParaBono } from './DatosParaBono';
import { MontosBono } from './MontosBono';
import { Button } from '@material-ui/core';


// TODO datos a traer desde la base de datos y que debe contener el formulario
// usuario movil
// fecha
// tipo de bono
// monto - mostrar desde la base de datos correspondiente al tipo de bono
// categoria


export const FormularioBonoDescuento = ({ user }) => {
    const [clearInput, setClearInput] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState({ id: '', value: '' });
    const [tipo, setTipo] = useState({ id: '', value: '' }); // tipo de extra
    const [selectType, setSelectType] = useState([]);
    const [driverList, setDriverList] = useState([]);
    const [fechaBono, setFechaBono] = useState('');
    const [ruta, setRuta] = useState({})
    const [listaExtras, setListaExtras] = useState([])
    const [selectExtras, setSelectExtras] = useState([])
    const [monto, setMonto] = useState('');
    const [cantidad, setCantidad] = useState(0);

    const handleIngreso = async (event) => {
        event.preventDefault()
        const data = {
            id_tipo_extra: tipo.id,
            id_usuarioMovil: selectedDriver.id,
            fecha: fechaBono,
            id_ruta: ruta.ruta_id,
            extras: selectExtras,
            cantidad: cantidad,
            monto: monto,
        }
        console.log('data: ', data)
    }

    // Restablecer el estado de limpieza una vez que se ha limpiado el input
    useEffect(() => {
        if (clearInput) {
            setClearInput(false); // Desactiva el flag después de limpiar el input
        }
    }, [clearInput]);

    useEffect(() => {
        setFechaBono('')
        setRuta({})
        setMonto('')
        setCantidad(0)
        setSelectExtras([])
    }, [selectedDriver, tipo])

    // Fetch data from the API when the component mounts
    useEffect(() => {
        const fetchSelectType = async () => {
            try {
                const response = await getMantenedores('tipo_extra', user);
                const formattedData = response.tipo_extra.map(item => ({
                    value: item.tipo.charAt(0).toUpperCase() + item.tipo.slice(1),
                    label: item.id
                }));
                setSelectType(formattedData);
            } catch (error) {
                console.error(error);
            }
        };

        fetchSelectType();
    }, []);

    const handleTipoSelect = (event, value) => {
        const selectedOption = selectType.find(option => option.value === value);
        if (selectedOption) {
            setTipo({ id: selectedOption.label, value: selectedOption.value });
        } else {
            setTipo({ id: '', value: '' });
        }
    };

    const handleFechaBono = (event) => {
        setFechaBono(event.target.value)
    }

    return (
        <>
            <div
                style={{
                    margin: "15px"
                }}
            >
                <Row>
                    <Col>
                        <Autocomplete
                            className='mb-2'
                            id='conductores-select'
                            freeSolo
                            options={selectType.map((option) => option.value)}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Bono o Descuento"
                                />
                            }
                            onChange={handleTipoSelect}
                            value={tipo.value || ''}
                        />
                    </Col>
                    {tipo.value && (
                        <DriverSelect
                            driverList={driverList}
                            setDriverList={setDriverList}
                            selectedDriver={selectedDriver}
                            setSelectedDriver={setSelectedDriver}
                            user={user}
                        />
                    )}
                </Row>
                {selectedDriver.value && tipo.value && (
                    <>
                        <Row>
                            <Col>
                                <TextField
                                    fullWidth
                                    label="Fecha de Bono"
                                    type="date"
                                    name="fecha_bono"
                                    variant="outlined"
                                    margin="normal"
                                    onChange={(e) => handleFechaBono(e)}
                                    value={fechaBono || ''}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Col>
                            {fechaBono && (
                                <Col>
                                    <DatosParaBono
                                        tipo={tipo}
                                        selectedDriver={selectedDriver}
                                        fechaBono={fechaBono}
                                        user={user}
                                        ruta={ruta}
                                        setRuta={setRuta}
                                    />
                                </Col>
                            )}
                        </Row>
                    </>
                )}
                {ruta && ruta.ruta && (
                    <MontosBono
                        tipo={tipo}
                        ruta={ruta}
                        monto={monto}
                        user={user}
                        setMonto={setMonto}
                        listaExtras={listaExtras}
                        setListaExtras={setListaExtras}
                        selectExtras={selectExtras}
                        setSelectExtras={setSelectExtras}
                        cantidad={cantidad}
                        setCantidad={setCantidad}
                    />
                )}
                {monto && cantidad != 0 && (
                    <Row>
                        <Col>
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: 'rgb(0, 155, 120)',
                                    color: '#FFF',
                                    marginBottom: 5,
                                    width: '100%'
                                }}
                                onClick={handleIngreso}
                            >
                                Ingresar nuevo {tipo.value}
                            </Button>
                        </Col>
                    </Row>
                )}
                <hr />

            </div>
        </>
    )
}
